var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9058 4.95068H2.12451C0.961402 4.95068 0.0151367 5.89695 0.0151367 7.06006V12.3101C0.0151367 13.4732 0.961402 14.4194 2.12451 14.4194H15.9058C17.0689 14.4194 18.0151 13.4732 18.0151 12.3101V7.06006C18.0151 5.89695 17.0689 4.95068 15.9058 4.95068ZM16.6089 12.3101C16.6089 12.6978 16.2935 13.0132 15.9058 13.0132H2.12451C1.73681 13.0132 1.42139 12.6978 1.42139 12.3101V7.06006C1.42139 6.67236 1.73681 6.35693 2.12451 6.35693H15.9058C16.2935 6.35693 16.6089 6.67236 16.6089 7.06006V12.3101Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31201 13.1885L8.31201 6.18453C8.31201 5.58253 8.62681 5.09451 9.01514 5.09451C9.40346 5.09451 9.71826 5.58253 9.71826 6.18453L9.71826 13.1885C9.71826 13.7905 9.40346 14.2786 9.01514 14.2786C8.62681 14.2786 8.31201 13.7905 8.31201 13.1885Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54297 8.98193H6.06096C6.44929 8.98193 6.76409 9.29673 6.76409 9.68506C6.76409 10.0734 6.44929 10.3882 6.06096 10.3882H3.54297C3.15464 10.3882 2.83984 10.0734 2.83984 9.68506C2.83984 9.29673 3.15464 8.98193 3.54297 8.98193Z",
    fill: "#677C95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9695 8.98193H14.4875C14.8758 8.98193 15.1906 9.29673 15.1906 9.68506C15.1906 10.0734 14.8758 10.3882 14.4875 10.3882H11.9695C11.5812 10.3882 11.2664 10.0734 11.2664 9.68506C11.2664 9.29673 11.5812 8.98193 11.9695 8.98193Z",
    fill: "#677C95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.0151367 0.685059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGroup);
export default __webpack_public_path__ + "static/media/button_group.854fcc0559a47c1f3f0e86573ffe2361.svg";
export { ForwardRef as ReactComponent };